import { useMutation } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import { downloadPrefillableFormFile } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';
import { downloadFileFromBlob } from '@dealstack/frontend/shared/files/downloadFile';

async function fetchPrefillableFormBlobAndFileName(
	fileId: string,
	instanceSignatureId: string
): Promise<{ blob: Blob; fileName: string } | undefined> {
	const response = await downloadPrefillableFormFile({ fileId, instanceSignatureId });
	if (!response) {
		const error = new Error('No response from download prefillable form file');
		Sentry.captureException(error, {
			extra: { fileId, instanceSignatureId },
		});
		return;
	}
	const blob = await response.blob();
	const fileName = response.headers.get('FileName') ?? 'Unknown';
	return { blob, fileName };
}

export const useDownloadPrefillableForm = () => {
	return useMutation({
		mutationKey: ['shareholder-contract-download-prefillable-form'],
		mutationFn: ({
			fileId,
			instanceSignatureId,
		}: {
			fileId: string;
			instanceSignatureId: string;
		}) => fetchPrefillableFormBlobAndFileName(fileId, instanceSignatureId),
		onSuccess: (data) => {
			const { blob, fileName } = data ?? {};
			if (!blob || !fileName) {
				return;
			}
			downloadFileFromBlob(blob, fileName);
		},
	});
};
